<template>
  <div class="comment-review d-flex align-items-center mb-3">
    <TacoRating
      :only-tacos="true"
      :deal="mockDeal"
      :taco-ratio="2"
    />
  </div>
</template>

<script>
// TODO:BRO-1276: import DTacoRating from '@appsumo/dorado-nuxt';
import TacoRating from '../../utilities/TacoRating.vue';

export default {
  name: 'PDPCommentRatings',
  components: {
    TacoRating,
  },
  props: {
    rating: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    mockDeal() {
      return {
        deal_review: {
          review_count: this.rating,
          average_rating: this.rating,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>

.comment-review div:not(:first-child) img {
  margin-left: 0.5rem;
}

</style>
